export default __webpack_public_path__ + "locales/sk/JavascriptSdk.json?hash=48f2a96815104140a0cfb96cba6e8271";